import { Component, OnInit, OnDestroy, ChangeDetectionStrategy/*, Renderer2, Inject*/ } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { CONSTANTS, NavigationUi } from '@app/constants';
import { ScreenService, DataService, PlatformService/*, ScrollService*/ } from '@app/data';
import { PlayerService } from '@app/player';
import { backgroundAnimation, fadeInAnimation } from '@app/animations';

@Component({
  selector: 'app-screen',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './screen.component.html',
  styleUrls: ['./screen.component.less'],
  animations: [backgroundAnimation, fadeInAnimation]
})
export class ScreenComponent implements OnInit, OnDestroy {

	public baseUrl = CONSTANTS.baseUrl;
	public activeItem$ = this.screenService.activeItem$;
  public activeScreen$ = this.screenService.activeScreen$;
  public player$ = this.playerService.player$;
  public showNavPlayer$ = this.playerService.showNavPlayer$;
  public showPlayBtn$ = this.screenService.showPlayBtn$;
  public next$ = this.screenService.next$;
  public prev$ = this.screenService.prev$;
  public playingVideoLink$ = this.playerService.playingVideoLink$;
  public isPlayingMini$ = this.playerService.isPlayingMini$;
  public isBrowser = this.platform.isBrowser;
  public strategy = this.isBrowser ? 'local' : 'global';
  private unsubscribe$: Subject<void> = new Subject();

  constructor(
    public route: ActivatedRoute,
    private platform: PlatformService,
    private screenService: ScreenService,
    private data: DataService,    
    private playerService: PlayerService,

  ) {}

  ngOnInit(): void {
    //console.log('ScreenComponent ActivatedRoute this.route ', this.route);

    /*this.activeItem$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      //console.log('**** ScreenComponent activeItem$ res ', res);
      console.log('**** ScreenComponent activeItem$ res[0] ', res[0]);

    });*/

    //this.showPlayBtn$.subscribe(_ => console.log('ScreenComponent showPlayBtn$ _ ', _));
  }

  ngOnDestroy(): void {
    //console.log('ScreenComponent ngOnDestroy');

    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public playVideo = (activeItem: any) => {
    //console.log('**** ScreenComponent playVideo activeItem ', activeItem);
    //console.log('ScreenComponent playVideo activeItem[0].url ', activeItem[0].url);

    this.data.setScrollIntoView('top');
    this.playerService.playVideo(activeItem[0]);
  }


  public isVisible = (player:any) => {

    if (player && player[0].showPlayer && !this.isBrowser) {
      return true;
    }
    else {
      return false;
    }
  }

  public isReady = (item:any) => {
    //console.log('ScreenComponent isReady item ', item);

    if (item && item.field_image_url) {
      return true;
    }
    else {
      return false;
    }
  }

  public scrollToTop = (): void => this.data.setScrollIntoView('top');
  public controlPlayer = (): void => this.playerService.controlPlayer();
}
